import {Component, computed, inject, Injectable, Input, signal} from '@angular/core';
import {NoCategoryHistoryContext} from '../../contexts/no-category-history.context';
import {TicketsFacade} from '../../facades/tickets.facade';
import {TICKET_CATEGORIES_LABEL, TicketCategory} from '../../models/ticket.model';
import {Button} from 'primeng/button';

@Injectable({providedIn: 'root'})
@Component({
	selector: 'app-no-category-history',
	host: { class: 'h-full p-3 border-round-2xl border-1 border-200' },
	imports: [Button],
	templateUrl: './no-category-history.html'
})
export class NoCategoryHistoryComponent {
	private readonly historyCtx = inject(NoCategoryHistoryContext);
	private readonly ticketsFacade = inject(TicketsFacade);

	@Input({ required: true })
	set type(value: TicketCategory) {
		this.typeSig.set(value);
	}

	readonly typeSig = signal<TicketCategory | null>(null);

	readonly categoryLabel = computed(() => {
		const type = this.typeSig();
		return type ? TICKET_CATEGORIES_LABEL[type] : '';
	});

	readonly history = computed(() => {
		const type = this.typeSig();
		if (!type) return [];
		return this.historyCtx.historyByCategory(type)();
	});

	undo() {
		const last = this.historyCtx.undoLast();
		if (!last) return;

		this.ticketsFacade.updateCategory(last.ticketId, last.from);
	}

	undoSingleTicket(ticketId: string) {
		const entry = this.historyCtx.popTicket(ticketId);
		if (!entry) return;

		this.ticketsFacade.updateCategory(entry.ticketId, entry.from);
	}
}

